import { config } from '@/env-exports';
import React from 'react';
import { OpenInNewWindowIcon } from '@radix-ui/react-icons';

export const conflictError: React.ReactNode = (
  <div>
    Looks like you already have an account with this email.<br/>
    Please refer below to sign into an existing account, or{' '}
    <a
      href={config.resetPasswordUrl}
      className="underline font-bold"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="reset your password"
    >
    reset your password
    </a>
    {' '}to continue.
  </div>
);

export const formDescription: React.ReactNode = (
  <div className="text-center ">
    By clicking 'Create account' you are confirming that you have read and agree to{' '}
    <a
      href="https://www.curtin.edu.au/about/governance/privacy/#Privacy_Statement"
      className="underline font-bold"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Curtin's Privacy Statement"
    >
      Curtin's Privacy Statement
    </a>
    ,{' '}
    <a
      href="https://s30991.pcdn.co/about/wp-content/uploads/sites/5/2022/12/Information_and_Communication_Technology_ICT_Appropriate_Use_Procedures.pdf"
      className="underline font-bold"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="ICT Procedures"
    >
      ICT Procedures
    </a>
    , and{' '}
    <a
      href="https://s30991.pcdn.co/about/wp-content/uploads/sites/5/2022/12/Information_Security_and_ICT_Appropriate_Use_Policy.pdf"
      className="underline font-bold"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="ICT Policy"
    >
      ICT Policy
    </a>
    .
  </div>
);

export const formFooter: React.ReactNode = (
  <div className="flex flex-col gap-y-6 text-center">
    <div>
      Already have an account?
    </div>
    <div>
      Domestic student:{' '}
      <a
        href={config.idpUrl}
        className="underline font-bold"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Sign in for domestic student applications"
      >
        Sign in
      </a>
      .
    </div>
    <div>
      International student:{' '}
      <a
        href={config.idpInternationalUrl}
        className="underline font-bold"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Sign in for international student applications"
      >
        Sign in
      </a>
      .
    </div>
    <div>
      Are you an agent applying on behalf of a student?{' '}
      <a
        href={config.agentIdpUrl}
        className="underline font-bold"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Agent sign In"
      >
        Click here
      </a>
      .
    </div>
  </div>
);

export const helpText: React.ReactNode = (
  <div className="flex flex-col gap-y-[20px] items-center justify-center text-center py-10 px-8 text-white">
    <div>
      Need help? Get in touch with{' '}
      <a
        href="https://students.connect.curtin.edu.au/app/contact"
        className="underline font-bold hover:text-deep-blue-100 focus-visible:ring-offset-transparent focus-visible:ring-offset-1"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Curtin Connect"
      >
        Curtin Connect.
      </a>
    </div>
    <div>For staff members, contact DTS on +61 8 9266 9000.</div>
  </div>
);

export const applyThroughAgentText: React.ReactNode = (
  <div className='flex flex-col gap-y-6 py-2'>
    <p className="text-2xl font-bold">You'll need to apply through an agent</p>
    <p>We're unable to create an account for you directly, but an agent can assist with your application.</p>
  </div>
);

export const hdrText: React.ReactNode = (
  <div>
    Are you applying for{' '}
    <a
      href="https://www.curtin.edu.au/study/higher-degree-by-research/"
      className="underline font-bold text-deep-blue hover:brightness-150 focus-visible:ring-offset-transparent focus-visible:ring-offset-1"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Higher Degree by Research (HDR)"
    >
      Higher Degree by Research (HDR)<OpenInNewWindowIcon className="inline-flex items-baseline me-1"/>
    </a>
    {' '}or{' '}
    <a
      href="https://www.curtin.edu.au/study/learning-experience/global-study/global-inbound/student-exchange/"
      className="underline font-bold text-deep-blue hover:brightness-150 focus-visible:ring-offset-transparent focus-visible:ring-offset-1"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Study Exchange Program (NA-EXCHN)"
    >
      Study Exchange Program (NA-EXCHN)<OpenInNewWindowIcon className="inline-flex items-baseline me-1"/>
    </a>
    ?
  </div>
);
